export default __webpack_public_path__ + "static/media/c.dc74216d.png";